module.exports = __webpack_public_path__ + "img/l3.0b77bacd.png";